import axios from 'axios';
import moment from 'moment';
import * as types from '@/store/mutationTypes';
import HOST from '@/store/host';

const state = {
  vacancyList: [],
  currentVacancy: null,
  relatedPosts: [],
  page: 1,
  totalRecords: 0,
  itemsPerPage: 0,
};
const actions = {
  getVacancyTotalRecords({ commit }) {
    return axios
      .get(`${HOST}/vacancies/page-count/`)
      .then(({ data }) => commit(types.GET_VACANCY_LIST_TOTAL_RECORDS, data.count))
      .catch(() => Promise.reject());
  },
  getVacancyList({ commit }, { page, itemsPerPage }) {
    return axios
      .get(`${HOST}/vacancies/`, {
        params: {
          ...page && { page },
          ...itemsPerPage && { items_per_page: itemsPerPage },
        },
      })
      .then(({ data }) => {
        commit(types.GET_VACANCY_LIST, { data, page });
      })
      .catch(() => Promise.reject());
  },
  getVacancyById({ commit }, id) {
    return axios
      .get(`${HOST}/vacancies/${id}/`)
      .then(({ data }) => commit(types.GET_VACANCY_BY_ID, data))
      .catch(() => Promise.reject());
  },
  clearVacancyData({ commit }) {
    commit(types.CLEAR_VACANCY_DATA);
  },
};

const mutations = {
  [types.GET_VACANCY_LIST_TOTAL_RECORDS](state, count) {
    state.totalRecords = count;
  },
  [types.GET_VACANCY_BY_ID](state, data) {
    state.currentVacancy = {
      ...data,
      date: moment(data.date).format('MM.DD.YYYY'),
    };
  },
  [types.GET_VACANCY_LIST](state, { data, page }) {
    state.vacancyList = data.map((el) => ({
      ...el,
      date: moment(el.date).format('MM.DD.YYYY'),
    }));
    state.page = page;
  },
  [types.CLEAR_VACANCY_DATA](state) {
    state.vacancyList = [];
    state.page = 1;
    state.itemsPerPage = 0;
    state.totalRecords = 0;
  },
};

export default {
  state,
  actions,
  mutations,
};
